export function mapCreateEvent() {
  gtag('event', 'map_create')
}
